import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
  numberColumn,
  dateColumn,
  createCheckboxConfig,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { VehicleModels } from '@models/vehicle.model';
import moment from 'moment-timezone';

export type UnsavedVehicleCellContext = CellTemplateContext<VehicleModels.Vehicle>;

export interface CreateUnsavedVehiclesTableConfigDependencies {
  imageCellTemplate: TemplateRef<UnsavedVehicleCellContext>;
  getLocationName: (row: VehicleModels.Vehicle) => string;
  checkboxEnabled?: boolean;
  actionsEnabled?: boolean;
  isRowDisabled?: (row: VehicleModels.Vehicle) => boolean;
}

export function createUnsavedVehiclesTableConfig(
  dependencies: CreateUnsavedVehiclesTableConfigDependencies,
): DatasetTableConfig<VehicleModels.Vehicle> {
  const builder = new ColumnBuilder<VehicleModels.Vehicle>();
  const tableBuilder = new TableConfigBuilder<VehicleModels.Vehicle>().columns([
      builder
        .column('id')
        .label('')
        .detailsModalLabel('VEHICLES.TABLE.IMAGE')
        .width('minmax(100px, 8%)')
        .cellTemplate(dependencies.imageCellTemplate)
        .build(),

      textColumn<VehicleModels.Vehicle>(
        'plate',
        'VEHICLES.TABLE.LICENCE_PLATE',
        {
          width: 'minmax(80px, 0.8fr)',
          mobileVisible: true,
        },
      ),

      numberColumn<VehicleModels.Vehicle>(
        'count',
        'VEHICLES.TABLE.RECOGNITIONS',
        {
          width: 'minmax(80px, 0.5fr)',
          mobileVisible: true,
          cardIcon: 'ui-icon-event',
        },
      ),

      dateColumn<VehicleModels.Vehicle>('lastSeen', 'VEHICLES.TABLE.LAST_SEEN', {
        width: 'minmax(100px, 1fr)',
        mobileVisible: true,
        valueExtractor: (row) => row.lastSeen,
        customFormat: 'YYYY MMM D, h:mm A',
        timezone: moment.tz.guess(),
      }),

      builder
        .column('edgeId')
        .label('VEHICLES.TABLE.LOCATION')
        .width('minmax(80px, 1fr)')
        .formatter((_, row) => dependencies.getLocationName(row))
        .mobileVisible()
        .cardIcon('ui-icon-location')
        .build(),
    ]);

  if (dependencies.checkboxEnabled) {
    tableBuilder.checkboxConfig(
      createCheckboxConfig({
        getRowId: (vehicle) => vehicle.plate,
        isRowDisabled: dependencies.isRowDisabled,
      }),
    );
  }

  if (dependencies.actionsEnabled !== false) {
    tableBuilder.actions([
      {
        id: 'add',
        icon: 'ui-icon-plus',
        tooltip: 'VEHICLES.TOOLTIPS.ADD',
      },
    ]);
  }

  return tableBuilder
    .trackBy('plate')
    .extend({
      responsive: {
        breakpoints: {
          card: 570,
        },
      }
    })
    .build();
}
